const CompanyView = ({ contact }) => {
  return contact.firmenname + " " + contact.kundenklasse;
};

export default CompanyView;
